import {getTranslations} from '@/common/utils';

const NAME = 'QualTables';

const initialState = {};

const TABLE_TRANSLATIONS_KEY = 'QUAL_TABLE.translations';

const TABLE_ACTIONS_ENUM = {
  GET_COMMENTS: 'getComments',
  SORTING: 'sorting'
};

const SORT_DIRECTIONS_ENUM = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: ''
};

const defaultTableState = {
  questionId: null,
  firstLoad: true,
  isReload: false,
  chunkSize: 10,
  data: [],
  filters: [],
  canShowFilters: true,
  header: [],
  loadingData: false,
  lastRowIndex: 1,
  hasMoreData: false,
  visibleFilterIdx: -1,
  action: TABLE_ACTIONS_ENUM.GET_COMMENTS,
  sortDir: SORT_DIRECTIONS_ENUM.NONE,
  translations: getTranslations(TABLE_TRANSLATIONS_KEY)
};

export const TABLE_ADD = 'QUAL_TABLE/TABLE/ADD_TABLE';
export const TABLE_REMOVE = 'QUAL_TABLE/TABLE/REMOVE_TABLE';
export const TABLE_DATA_LOAD = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD';
export const TABLE_DATA_LOAD_START = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD_START';
export const TABLE_DATA_LOAD_SUCCESS = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD/SUCCESS';
export const TABLE_DATA_LOAD_ERROR = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD/ERROR';
export const TABLE_DATA_LOAD_END = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD/END';
export const TABLE_UPDATE_SCALAR_PROPERTIES = 'QUAL_TABLE/TABLE/TABLE_UPDATE_SCALAR_PROPERTIES';
export const TABLE_SORT_CHANGE = 'QUAL_TABLE/TABLE/TABLE_SORT_CHANGE';

export const FILTER_TOGGLE = 'QUAL_TABLE/FILTER/FILTER_TOGGLE';
export const FILTER_TOGGLE_START = 'QUAL_TABLE/FILTER/FILTER_TOGGLE/START';
export const FILTER_TOGGLE_SUCCESS = 'QUAL_TABLE/FILTER/FILTER_TOGGLE/SUCCESS';
export const FILTER_TOGGLE_ERROR = 'QUAL_TABLE/FILTER/FILTER_TOGGLE/ERROR';
export const FILTERS_UPDATE = 'QUAL_TABLE/FILTER/FILTERS_UPDATE';
export const FILTERS_HIDE_IN_ALL_TABLES = 'QUAL_TABLE/FILTER/FILTERS_HIDE_IN_ALL_TABLES';

export const FILTER_APPLY = 'QUAL_TABLE/FILTER/FILTER_APPLY';
export const FILTER_APPLY_START = 'QUAL_TABLE/FILTER/FILTER_APPLY/START';
export const FILTER_APPLY_SUCCESS = 'QUAL_TABLE/FILTER/FILTER_APPLY/SUCCESS';
export const FILTER_APPLY_ERROR = 'QUAL_TABLE/FILTER/FILTER_APPLY/ERROR';

export default {
  NAME,
  initialState,
  TABLE_ACTIONS_ENUM,
  SORT_DIRECTIONS_ENUM,
  defaultTableState,
  ACTION_NAMES: {
  TABLE_ADD,
  TABLE_REMOVE,
	TABLE_DATA_LOAD,
	TABLE_DATA_LOAD_START,
	TABLE_DATA_LOAD_SUCCESS,
	TABLE_DATA_LOAD_ERROR,
	TABLE_DATA_LOAD_END,
  TABLE_UPDATE_SCALAR_PROPERTIES,
  TABLE_SORT_CHANGE,
	FILTER_TOGGLE,
	FILTER_TOGGLE_START,
	FILTER_TOGGLE_SUCCESS,
	FILTER_TOGGLE_ERROR,
	FILTER_APPLY,
	FILTER_APPLY_START,
	FILTER_APPLY_SUCCESS,
	FILTER_APPLY_ERROR,
	FILTERS_UPDATE,
	FILTERS_HIDE_IN_ALL_TABLES
  }
}


// WEBPACK FOOTER //
// ./components/qual/Table/ducks/constants.js